import { ActionType, ComponentType } from '../../enums';

export interface CreateSearchSuggestionDisplayEventPayloadOptions {
  componentVariant: 'destinations' | 'properties' | 'destinations and properties';
  count?: number | undefined;
  searchRecent: string[];
  viewMode: 'list' | 'title';
}

export interface CreateSearchSuggestionDisplayEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    component_variant: string;
    group_name: string;
    count: number | null | undefined;
    search_recent: string[];
    view_mode: string;
  };
}

export const createSearchSuggestionDisplayEventPayload = ({
  count,
  searchRecent,
  viewMode,
  componentVariant,
}: CreateSearchSuggestionDisplayEventPayloadOptions): CreateSearchSuggestionDisplayEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.DISPLAY,
      component_type: ComponentType.SEARCH,
      component_variant: componentVariant,
      group_name: 'recent search',
      count,
      search_recent: searchRecent,
      view_mode: viewMode,
    },
  };
};
